/**
 * SegmentLeaderboard (source=cohort_membership, type=segment_leaderboard).
 * Backend: { chart: 'table', rows: [{cohort_id, name, user_count, wow_delta}] }
 */
import React from 'react';
import { Table, TableContainer, Thead, Tbody, Tr, Th, Td, Text, Badge } from '@chakra-ui/react';

export default function SegmentLeaderboard({ data }) {
  const rows = data?.rows || [];
  return (
    <TableContainer maxH="520px" overflowY="auto">
      <Table size="sm" variant="simple">
        <Thead position="sticky" top={0} bg="white" zIndex={1}>
          <Tr>
            <Th>#</Th>
            <Th>Cohort</Th>
            <Th isNumeric>Members</Th>
            <Th>Δ WoW</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((r, i) => (
            <Tr key={r.cohort_id || i}>
              <Td fontSize="xs" color="gray.500">{i + 1}</Td>
              <Td fontSize="xs">{r.name}</Td>
              <Td fontSize="xs" isNumeric fontWeight="semibold">{Number(r.user_count).toLocaleString()}</Td>
              <Td fontSize="xs">{r.wow_delta == null ? <Text as="span" color="gray.400">—</Text> :
                <Badge colorScheme={r.wow_delta >= 0 ? 'green' : 'red'}>{Math.abs(r.wow_delta).toFixed(1)}%</Badge>}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
